/**
 * A talent-list row, as the business pages draw it — one mapping for every
 * list: the business context's roster and each server-paged lens list.
 *
 * It was written out three times (the context, and each page's archived list),
 * each a copy of the last. The list endpoint returns the split name and the
 * VISIBLE journey's route (`journeyOriginCountry` / `journeyDestinationCountry`
 * — an invited talent's route lives on the citizen's journey); the pages read
 * `name` and `originCountry` / `destinationCountry`.
 */
import type { PipelineRow } from '@tonnie/sdk';

import type { Talent } from '@/core/types/business';

export function toTalentView(row: PipelineRow, unknownName: string): Talent {
  const name = `${row.firstName || ''} ${row.lastName || ''}`.trim() || row.email || unknownName;
  return {
    // The local `Talent` declares the fields the pages read; the row carries
    // them under the SDK's names, so the spread is the one place they meet.
    ...(row as unknown as Talent),
    name,
    originCountry: row.journeyOriginCountry ?? row.originCountry ?? null,
    destinationCountry: row.journeyDestinationCountry ?? row.destinationCountry ?? null,
  };
}
